import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt, faUserCircle } from '@fortawesome/free-solid-svg-icons'

import { useAuth0 } from "../../react-auth0-spa";

import './styles.scss';

const NavbarDashboard = () => {
  const { logout } = useAuth0();
  const onHandleLogout = (e) => {
    e.preventDefault();
    logout({
      returnTo: window.location.origin
    });
  };

  return (
    <div className="navbar-dashboard">
      <div className="user-info">
        <div className="profile">
          <Link to="/profile">
            <FontAwesomeIcon
              icon={faUserCircle}
              size="lg"
            />
          </Link>
        </div>
        <div className="auth-container">
          <button
            className="auth-logout-link"
            onClick={onHandleLogout}
          >
            <FontAwesomeIcon
              icon={faSignOutAlt}
              size="sm"
            />{' '}
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}

export default NavbarDashboard;
